import { useEffect, useState } from "react";
import geofenceService from "../../../api/geofenceService";

export default function AdminGeoFencePage() {
    const [zones, setZones] = useState([]);
    const [editId, setEditId] = useState(null);

    const [form, setForm] = useState({
        name: "",
        centerLat: "",
        centerLng: "",
        radiusMeters: 500
    });

    const loadZones = async () => {
        try {
            const data = await geofenceService.getZones();
            setZones(Array.isArray(data) ? data : []);
        } catch (e) {
            alert("Failed to load zones");
        }
    };

    useEffect(() => {
        loadZones();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const zone = {
            name: form.name,
            centerLat: Number(form.centerLat),
            centerLng: Number(form.centerLng),
            radiusMeters: Number(form.radiusMeters)
        };

        try {
            if (editId) {
                await geofenceService.updateZone(editId, zone);
            } else {
                await geofenceService.createZone(zone);
            }

            setForm({
                name: "",
                centerLat: "",
                centerLng: "",
                radiusMeters: 500
            });
            setEditId(null);
            await loadZones();
        } catch (err) {
            console.error(err);
            alert("Operation failed");
        }
    };

    const editZone = (z) => {
        setEditId(z.id);
        setForm({
            name: z.name ?? "",
            centerLat: z.centerLat ?? "",
            centerLng: z.centerLng ?? "",
            radiusMeters: z.radiusMeters ?? 500
        });
    };

    const remove = async (id) => {
        if (!window.confirm("Delete zone?")) return;

        await geofenceService.deleteZone(id);
        await loadZones();
    };

    return (
        <div className="p-3">
            <h3>GeoFence Management</h3>

            <form onSubmit={handleSubmit} className="mb-4">
                <input
                    placeholder="Name"
                    className="form-control mb-2"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                />

                <input
                    placeholder="Latitude"
                    className="form-control mb-2"
                    value={form.centerLat}
                    onChange={(e) => setForm({ ...form, centerLat: e.target.value })}
                    required
                />

                <input
                    placeholder="Longitude"
                    className="form-control mb-2"
                    value={form.centerLng}
                    onChange={(e) => setForm({ ...form, centerLng: e.target.value })}
                    required
                />

                <input
                    placeholder="Radius (m)"
                    className="form-control mb-2"
                    value={form.radiusMeters}
                    onChange={(e) => setForm({ ...form, radiusMeters: e.target.value })}
                    required
                />

                <button className="btn btn-primary">
                    {editId ? "Update Zone" : "Save Zone"}
                </button>

                {editId && (
                    <button
                        type="button"
                        className="btn btn-secondary ms-2"
                        onClick={() => {
                            setEditId(null);
                            setForm({
                                name: "",
                                centerLat: "",
                                centerLng: "",
                                radiusMeters: 500
                            });
                        }}
                    >
                        Cancel
                    </button>
                )}
            </form>

            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Lat</th>
                        <th>Lng</th>
                        <th>Radius</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {zones.map((z) => (
                        <tr key={z.id}>
                            <td>{z.id}</td>
                            <td>{z.name}</td>
                            <td>{z.centerLat}</td>
                            <td>{z.centerLng}</td>
                            <td>{z.radiusMeters}</td>
                            <td>
                                <button
                                    className="btn btn-sm btn-warning me-2"
                                    onClick={() => editZone(z)}
                                >
                                    Edit
                                </button>

                                <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => remove(z.id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}